// Feed-bank aging cues — pure, testable (no React/axios). Shared by the bank
// summary indicator, the Feed Bank page, and the Plan-popup bank column.
//
// Thresholds (DEFAULTS — confirm with Brad): fresh < 14d, aging 14–28d, stale > 28d.
export const FRESH_MAX_DAYS = 14;   // [0, 14)  → fresh
export const AGING_MAX_DAYS = 28;   // [14, 28] → aging; ( > 28 ) → stale

export type AgeBucket = 'fresh' | 'aging' | 'stale';

export const agingBucket = (days: number): AgeBucket =>
  days > AGING_MAX_DAYS ? 'stale' : days >= FRESH_MAX_DAYS ? 'aging' : 'fresh';

export const AGING_COLORS: Record<AgeBucket, string> = {
  fresh: '#15803d',  // green
  aging: '#b45309',  // amber
  stale: '#b91c1c',  // red
};

export const agingColor = (days: number): string => AGING_COLORS[agingBucket(days)];

// Whole days since an ISO timestamp (local clock). Never negative.
export const daysSince = (iso: string | null | undefined): number => {
  if (!iso) return 0;
  const then = new Date(iso).getTime();
  if (isNaN(then)) return 0;
  return Math.max(0, Math.floor((Date.now() - then) / 86400000));
};
